export const PLAN_FEATURES = [
  'Unlimited cases & patients',
  'Scan services & lab orders',
  'Priority support',
];
